import { Controller } from 'react-hook-form'

export default ({
  name,
  control,
  label,
  defaultValue = '',
  disabled = false,
  rules = {},
  validator = {},
  className = ''
}) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    rules={rules}
    render={({ field }) => (
      <>
        <label className={`input ${className} ${validator.hasError ? 'validator' : ''}`}
          {...(validator.hasError && validator.hasError(name) ? {'aria-invalid': true} : {})}
        >
          <span className="label">{label}</span>
          <input
            {...field}
            value={field.value || ''}
            disabled={disabled}
          />
        </label>
        {validator.getErrorMessage && (
          <div className="validator-hint hidden mt-0 pt-2 empty:py-[0.6rem]">
            {validator.getErrorMessage(name)}
          </div>
        )}
      </>
    )}
  />
)